import { z } from 'zod';

import { DCTaskStatus, DCTaskType, TaskUrgency } from '@/models/doc-cirrus/DCTask.ts';

// TODO: figure out uses of commented fields
export const task_form_schema = z
    .object({
        instance_id: z.string(),
        employee_id: z.string().optional().nullable(),
        patient_id: z.string().optional(),
        // activity_id: z.string().optional(),
        title: z.string(),
        type: z.enum(DCTaskType),
        status: z.enum(DCTaskStatus),

        // orig_type: z.string().optional(),
        task_type: z.string().optional(),
        urgency: z.enum(TaskUrgency),
        employee_name: z.string().optional(),
        patient_name: z.string().optional(),
        // activity_type: z.string().optional(),

        details: z.string().optional(),
        is_all_day: z.boolean().optional(),
        // is_group: z.boolean().optional(),
        // is_session_wide: z.boolean().optional(),
        roles: z.array(z.string()).optional(),
        candidates: z.array(z.string()).optional(),
        locations: z.array(z.string()).min(1, 'At least one location must be provided.'),
        // activities: z.array(z.string()).optional(),

        alert_time: z.iso.datetime(),
        // template_alert_time_absolute: z.number().optional(),
        // template_alert_time_interval: z.string().optional(),
    })
    .refine(
        ({ roles, candidates }) => {
            const has_roles = Array.isArray(roles) && roles.length > 0;
            const has_candidates = Array.isArray(candidates) && candidates.length > 0;
            return has_roles || has_candidates;
        },
        {
            message: 'At least one role or one candidate must be provided.',
            path: ['roles', 'candidates'],
        }
    );
